module.exports = __webpack_public_path__ + "static/media/banner-product-1.169d98db.png";